<template>
	<div class="login">
		<el-card class="box-card">
			<div slot="header" class="clearfix">
				<span>后台管理系统UI</span>
			</div>
			<div>
				<el-form :model="loginForm" status-icon ref="loginForm" :rules="rules">
					<el-form-item label="用户名" label-width="80px" prop="username">
						<el-input type="text" v-model="loginForm.username"></el-input>
					</el-form-item>
					<el-form-item label="密码" label-width="80px" prop="password">
						<el-input type="password" v-model="loginForm.password"></el-input>
					</el-form-item>
					<el-form-item>
						<el-button type="primary" @click="submitForm('loginForm')">登录</el-button>
					</el-form-item>
				</el-form>
			</div>
		</el-card>
	</div>

</template>

<script>
	import api from "../api";
	import {
		mapMutations
	} from "vuex";
	export default {
		data() {
			// 验证规则
			var validateUserName = (rule, value, callback) => {
				if (value === "") {
					callback(new Error("请输入用户名"));
				} else if (value.length < 4) {
					callback(new Error("长度不够"));
				} else {
					callback();
				}
			};
			var validatePassWord = (rule, value, callback) => {
				if (value === "") {
					callback(new Error("请输入密码"));
				} else {
					callback();
				}
			};
			var validateconfigurePassword = (rule, value, callback) => {
				if (value === "") {
					callback(new Error("请再次输入密码"));
				} else if (value !== this.registerForm.password) {
					callback(new Error("两次输入密码不一致!"));
				} else {
					callback();
				}
			};

			return {
				currentIndex: "login",
				loginForm: {
					username: "",
					password: "",
				},
				registerForm: {
					username: "",
					password: "",
					configurePassword: "",
					email: "",
				},
				activeTab: "login",
				rules: {
					// 邮箱
					email: [{
							required: true,
							message: '请填写邮箱',
							trigger: 'blur'
						},
						{
							type: 'string',
							message: '邮箱格式不正确',
							trigger: 'blur',
							transform(value) {
								if (!/^\w+((-\w+)|(\.\w+))*@[A-Za-z0-9]+((\.|-)[A-Za-z0-9]+)*\.[A-Za-z0-9]+$/.test(
										value)) {
									return true
								} else {}
							}
						},
						{
							type: 'string',
							message: '长度不能超过30位',
							trigger: 'blur',
							max: 30
						}
					],
					username: [{
						validator: validateUserName,
						trigger: "blur",
					}, ],
					password: [{
						validator: validatePassWord,
						trigger: "blur",
					}, ],
					configurePassword: [{
						validator: validateconfigurePassword,
						trigger: "blur",
					}, ],
				},
			};
		},
		methods: {
			...mapMutations("login", ["setUser"]),
			submitForm(formName) {
				this.$refs[formName].validate((valid) => {
					if (valid) {
							// 登录
							// this.$bus.$emit("loginnn", this.loginForm);
							this.$router.push("/Worktable");
						
					} else {
						return;
					}
				});
			},
			handleTabsClick(tab) {
				this.activeTab = tab.name;
			},
		},
	};
</script>

<style scoped lang="less">
	.login {
		// background: url("../assets/bg2.jpeg");
		text-align: center;
		background-color: #c4c4c4;
		width: 100%;
		height: 100%;
		position: fixed;
		background-size: 100% 100%;

		.box-card {
			// opacity: 0.3;
			position: absolute;
			background-color: #fff;
			right: 15%;
			top: 35%;
			width: 400px;
			border: 0;

			/deep/ .el-form-item {
				background-color: unset !important;
			}

			/deep/ .el-input input {
				color: red;
				background: transparent !important;
			}

			.el-button {
				background: red;
				border: 0;
				color: #fff;
				font-weight: bold;
			}

		}

		.el-form {
			color: red;
		}

		span {
			color: #000;
			font-size: 18px;
			font-weight: bold;
		}
	}
</style>
